module.exports = __webpack_public_path__ + "img/place-view-tabs02.4db02bf0.svg";